<template>
 <v-container >

    <v-row class="stores-row d-flex flex-column space-between" >

      <v-form >

      <v-col cols="12 plr-none" class="card d-flex align-center " >
           <v-img
            :src="require('../assets/stores/01 wint.png')"
            height="96"
            contain
          />
          <p class="store-title">Wint<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja"  v-model="store.wint" @change="check($event)"></v-checkbox>
      </v-col>
  
      <v-col cols="12 plr-none" class=" card d-flex align-center ">
           <v-img
            :src="require('../assets/stores/02 Delmax.png')"
            height="96"
            contain
          />
        <p class="store-title">Delmax<br><span></span></p>
        <v-checkbox input-value="" class="float-right" value="veleprodaja" v-model="store.delmax" @change="check($event)"  ></v-checkbox>
      </v-col>

       <v-col cols="12 plr-none" class=" card d-flex align-center ">
           <v-img
            :src="require('../assets/stores/logo-ca.png')"
            height="96"
            contain
          />
            <p class="store-title">Ciak Auto<br><span></span></p>
            <v-checkbox input-value="" value="veleprodaja" v-model="store.ciak" @change="check($event)" ></v-checkbox>
      </v-col> 

      <v-col cols="12 plr-none" class=" card d-flex align-center ">
           <v-img
            :src="require('../assets/stores/07 Auto-line.png')"
            height="96"
            contain
          />
        <p class="store-title">Auto Line<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.autoline" @change="check($event)" ></v-checkbox>
      </v-col>

      <v-col cols="12 plr-none" class=" card d-flex align-center ">
           <v-img
            :src="require('../assets/stores/08 Gazela.png')"
            height="96"
            contain
          />
        <p class="store-title">Gazela Komerc<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.gazela" @change="check($event)" ></v-checkbox>
      </v-col>

      <v-col cols="12 plr-none" class=" card d-flex align-center ">
           <v-img
            :src="require('../assets/stores/09 Automaterijal.png')"
            height="96"
            contain
          />
        <p class="store-title">Automaterijal<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.automaterijal" @change="check($event)" ></v-checkbox>
      </v-col>

      <v-col cols="12 plr-none" class=" card d-flex align-center ">
           <v-img
            :src="require('../assets/stores/04 KIT.png')"
            height="96"
            contain
          />
        <p class="store-title">Kit Komerc<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.kit" @change="check($event)" ></v-checkbox>
      </v-col>


      <v-col cols="12 plr-none" class="card card-last d-flex align-center ">
           <v-img
            :src="require('../assets/stores/12 Vudim.png')"
            height="96"
            contain
          />
        <p class="store-title">Vudim Trade<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.vudim" @change="check($event)"></v-checkbox>
      </v-col>

      <v-col cols="12 plr-none" class="card card-last d-flex align-center ">
           <v-img
            :src="require('../assets/stores/sanel_logo.png')"
            height="96"
            contain
          />
        <p class="store-title">Sanel<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.sanel" @change="check($event)"></v-checkbox>
      </v-col>

      <v-col cols="12 plr-none" class="card card-last d-flex align-center ">
           <v-img
            :src="require('../assets/stores/logo-ic-s-rubom.png')"
            height="96"
            contain
          />
        <p class="store-title">Inter Cars<br><span></span></p>
        <v-checkbox input-value="" value="veleprodaja" v-model="store.inter" @change="check($event)"></v-checkbox>
      </v-col>


      <v-btn id="button-hide" class="fixed" height="50" rounded color="primary" dark @click="updateStore">POTVRDI</v-btn>

      </v-form>
    </v-row>
 </v-container>
</template>

<script>
  import firebase from 'firebase'
  import {db,fb} from '../main'
  export default {
  
  name: 'Stores',
  data() {
    return {

      store: {
        wint:null,
        delmax:null,
        kit:null,
        ciak:null,
        rapidex:null,
        autoline:null,
        automaterijal:null,
        gazela:null,
        euroauto:null,
        autopromet:null,
        vadim:null,
        safety:null,
        lukena:null,
        sanel:null,
        inter:null,
      },

    }
    
  },    
 firestore() {
      const user = fb.auth().currentUser
      return {
        store: db.collection(`accounts`).doc(user.uid),
      }
    },
    
    methods: {
      
      check: function(e) {

        //To count how many are checked/ticked
        // document.querySelectorAll("[type=checkbox]:checked").length == 7

        //To check a specific checkbox...
        if (document.querySelectorAll("[type=checkbox]:checked") ){
            document.getElementById('button-hide').style.display = "block";
        }
        else if (document.querySelectorAll("[type=checkbox]:checked").length === 0){
            document.getElementById('button-hide').style.display = "none";
        }
        else {
      
            document.getElementById('button-hide').style.display = "none";
        }
   
  },

        updateStore() {
            this.$firestore.store.set(this.store)
            // this.$alert("Nalog je uspešno izmenjen");
             this.$router.push('/')
      },

    },

      
}

</script>


<style>
 #button-hide {
   display: none;
 }
  .v-icon.v-icon {
    font-size: 35px;
  }
  .v-application--is-ltr .v-input--selection-controls__input{
    margin-right: 20px!important;
  }
  .card .v-image__image  {
    background-position:left!important;
    margin-left: 20px;
  }
  .card {
    border-bottom: 1px solid #EBECEC;
  }
  .card:last-of-type {
    margin-bottom: 80px!important;
  }
  .fixed {
    position: fixed;
    bottom: 24px;
    width: 90%!important;
    left: 50%;
    transform: translate(-50%);
  }

  .store-title {
    float: left;
    width: 100%;
    position: relative;
    left: -32px;
    top: 10px;
    font-size: 16px;
  }
  .store-title span {
    font-size: 14px;
    color:#00000099;
  }
    @media only screen and (max-device-width: 414px) {
    .card:last-of-type {
    margin-bottom: 140px!important;
  }
    }
</style>